import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-chevron-left\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.09015 10.9393L8.51476 3.51471L9.57542 4.57537L2.15081 12L9.57539 19.4246L8.51473 20.4852L1.09015 13.0606L1.09014 13.0607L0.0294818 12L0.0294894 12L0.0294417 11.9999L1.0901 10.9393L1.09015 10.9393Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol